import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0590a674&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0590a674&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=0590a674&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0590a674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0590a674')) {
      api.createRecord('0590a674', component.options)
    } else {
      api.reload('0590a674', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0590a674&scoped=true", function () {
      api.rerender('0590a674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/occurrences/list/index.vue"
export default component.exports